import { render } from "./Reddit.vue?vue&type=template&id=4d53f1ad"
import script from "./Reddit.vue?vue&type=script&lang=js"
export * from "./Reddit.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__